<template>
    <div class="dropdown  ml1 mr2 relative relative" @click="toggleDropdown = !toggleDropdown">
        <svg class="pointer usersettingsicon" width="30" height="30" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.387 6.25333C11.6025 6.49149 11.9088 6.62736 12.23 6.62736C12.5512 6.62736 12.8574 6.49149 13.073 6.25333L13.618 5.65333C13.9399 5.29676 14.4513 5.18143 14.8951 5.36535C15.3388 5.54927 15.6187 5.99261 15.594 6.47233L15.553 7.28433C15.5364 7.60526 15.6567 7.91817 15.8839 8.1454C16.1112 8.37264 16.4241 8.49289 16.745 8.47633L17.557 8.43433C18.037 8.40952 18.4806 8.68974 18.6644 9.13387C18.8481 9.57801 18.7322 10.0897 18.375 10.4113L17.775 10.9563C17.5363 11.1714 17.4 11.4776 17.4 11.7988C17.4 12.1201 17.5363 12.4263 17.775 12.6413L18.375 13.1863C18.7322 13.5079 18.8481 14.0196 18.6644 14.4638C18.4806 14.9079 18.037 15.1881 17.557 15.1633L16.745 15.1213C16.4239 15.1047 16.1108 15.2251 15.8835 15.4526C15.6563 15.68 15.5361 15.9932 15.553 16.3143L15.594 17.1263C15.6187 17.606 15.3388 18.0494 14.8951 18.2333C14.4513 18.4172 13.9399 18.3019 13.618 17.9453L13.073 17.3453C12.8574 17.1072 12.5512 16.9713 12.23 16.9713C11.9088 16.9713 11.6025 17.1072 11.387 17.3453L10.843 17.9453C10.5208 18.3015 10.0095 18.4165 9.5658 18.2327C9.12211 18.0489 8.84195 17.606 8.86599 17.1263L8.90699 16.3143C8.92589 15.9922 8.80681 15.6773 8.57952 15.4483C8.35224 15.2193 8.03822 15.0979 7.71599 15.1143L6.90399 15.1563C6.42435 15.1804 5.9814 14.9002 5.7976 14.4565C5.6138 14.0128 5.72886 13.5015 6.08499 13.1793L6.68499 12.6343C6.92311 12.419 7.05896 12.1129 7.05896 11.7918C7.05896 11.4708 6.92311 11.1647 6.68499 10.9493L6.08499 10.4043C5.732 10.0821 5.61839 9.57349 5.80078 9.13174C5.98316 8.68999 6.42252 8.40963 6.89999 8.43033L7.71199 8.47233C8.03343 8.48977 8.34716 8.36991 8.57507 8.14257C8.80298 7.91523 8.92363 7.60181 8.90699 7.28033L8.86599 6.46833C8.84195 5.98868 9.12211 5.54573 9.5658 5.36193C10.0095 5.17813 10.5208 5.29319 10.843 5.64933L11.387 6.25333Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12.23" cy="11.7953" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="0.75" y="1.06531" width="22.5" height="22.5" rx="1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="dropdown-bubble absolute p2 drop-shadow op0 no-pointer-events flex flex-column justify-center" :class="{dropdownAppear: toggleDropdown}">
            <div class="my1 mx2" v-for="item in menuItems" :key="'item' + item.id">
                <a class="dropdown-menu-link pointer" @click="openMenuLightbox(item.modal)">{{item.name}}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from "../event-bus";

export default {
  name: 'dropdown',
  data() {
    return {
        toggleDropdown: false,
    }
  },
  props: {
      'menuItems': Object,
  },
  methods: {
      openMenuLightbox(modal){
          console.log(modal);
          EventBus.$emit('open_' + modal);
      }
  }

}
</script>

<style scoped>

</style>